import { useState, useEffect } from 'react'

export default (values, validator) => {
  const [valid, _validateSchema] = useState(false)
  useEffect(() => {
    validator({ ...values }, _validateSchema)
  }, [values])

  return valid
}
